import React from 'react';
import ViewSmsSettingComponent from '../../../Components/SmsSetting/ViewSmsSetting';

export default function ViewSmsSetting() {
    return (
        <div className='page-body'>
            <ViewSmsSettingComponent />
        </div>
    );
}